"use strict";

exports.__esModule = true;
exports.setIsAuthMenuOpen = setIsAuthMenuOpen;
exports.setIsMiniMode = setIsMiniMode;
exports.setIsMenuOpen = setIsMenuOpen;
exports.setIsMobileMenuOpen = setIsMobileMenuOpen;
exports.setIsMiniSwitchVisibility = setIsMiniSwitchVisibility;

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function setIsAuthMenuOpen(payload) {
  return {
    type: types.SET_IS_AUTH_MENU_OPEN,
    payload: payload
  };
}

function setIsMiniMode(payload) {
  return {
    type: types.SET_IS_MINI_MODE,
    payload: payload
  };
}

function setIsMenuOpen(payload) {
  return {
    type: types.SET_IS_MENU_OPEN,
    payload: payload
  };
}

function setIsMobileMenuOpen(payload) {
  return {
    type: types.SET_IS_MOBILE_MENU_OPEN,
    payload: payload
  };
}

function setIsMiniSwitchVisibility(payload) {
  return {
    type: types.SET_IS_MINI_SWITCH_VISIBILITY,
    payload: payload
  };
}